import Image from '@/components/image/NextImage';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import { Wrapper } from './styles';
import { NarratorImageProps } from './types';

const NarratorImage = ({ program, theme = 'small', alignment = 'center' }: NarratorImageProps) => {
	const narrator = program?.narrator ?? program?.guest;

	if (!narrator?.headshot?.url) return null;

	return (
		<Wrapper $theme={theme} $alignment={alignment}>
			<Image
				src={formatResizedUrl(narrator.headshot.url, 160, 160)}
				alt=""
				width={80}
				height={80}
				style={{ width: '100%', height: 'auto' }}
			/>
		</Wrapper>
	);
};

export default NarratorImage;
